import { useState } from 'react';
import * as S from './styles';

import { SubMenu } from './SubMenu';

export type MenuItem = {
  label: string;
  path?: string;
  icon: React.ElementType;
  permissions?: string[];
  profiles?: string[];
  subItems?: MenuItem[];
};

interface MenuProps {
  items: (MenuItem | null)[];
  isActive: (path: string) => boolean;
  onItemClick: (path?: string) => void;
  onSubMenuItemClick?: (path?: string) => void;
}

export const Menu = ({ items, isActive, onItemClick, onSubMenuItemClick }: MenuProps) => {
  const [idSubMenuOpen, setIdSubMenuOpen] = useState<number | null>(null);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const toggleSubMenu = (event?: React.MouseEvent<HTMLElement>, index?: number) => {
    if (index !== undefined) {
      setAnchorEl(event?.currentTarget ?? null);
      setIdSubMenuOpen(idSubMenuOpen === index ? null : index);
    } else {
      setAnchorEl(null);
      setIdSubMenuOpen(null);
    }
  };

  return !items.length ? (
    <></>
  ) : (
    <S.Container>
      <S.Content>
        {items?.map(
          (item, index) =>
            item && (
              <S.Item
                key={`${index}-${item?.label}`}
                isActive={isActive(item.path ?? '')}
                onClick={event => {
                  item.subItems ? toggleSubMenu(event, index) : onItemClick(item.path);
                }}
              >
                <S.Icon>
                  <item.icon />
                </S.Icon>
                <S.Text title={item.label}>{item.label}</S.Text>
                {item.subItems?.length && (
                  <SubMenu
                    anchorEl={anchorEl}
                    setAnchorEl={setAnchorEl}
                    id={index}
                    isOpen={idSubMenuOpen === index}
                    items={item.subItems}
                    closeMenu={() => setIdSubMenuOpen(null)}
                    onClickItem={onSubMenuItemClick}
                  />
                )}
              </S.Item>
            )
        )}
      </S.Content>
    </S.Container>
  );
};
